module.exports = __webpack_public_path__ + "static/media/1POLICY31.1cb19678.jpg";